import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchUserDetails } from 'common/services/api/Users/Users.thunk';
import { UserDetails } from 'common/types/Entities';
import { filterReducers, FilterState } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

type UsersSliceState = FilterState & {
    userDetails: UserDetails | null,
    processingUserDetails: boolean;
};

const initialState: UsersSliceState = {
    userDetails: null,
    processingUserDetails: false,
    filters: {
        keywords: []
    }
};

const usersSlice = createSlice({
    name: 'users',
    initialState,

    reducers: (create) => ({
        ...filterReducers,
        setUserDetails: create.reducer((state, action: PayloadAction<UserDetails>) => {
            state.userDetails = action.payload;
        })
    }),

    extraReducers: builder => {
        builder.addCase(fetchUserDetails.pending, state => {
            state.userDetails = null;
        });
        builder.addCase(fetchUserDetails.fulfilled, (state, action: PayloadAction<UserDetails>) => {
            state.userDetails = action.payload;
        });
        builder.addCase(fetchUserDetails.rejected, state => {
            state.userDetails = null;
        });
    }
});

// eslint-disable-next-line no-restricted-syntax
export default usersSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters, setUserDetails } = usersSlice.actions;
export const selectFilters = (state: RootState) => state.users.filters;
export const selectUserDetails = (state: RootState) => state.users.userDetails;
export const selectUserDetailsProcessing = (state: RootState) => state.users.processingUserDetails;
